/* VEXiAL — página de producto · comportamiento
   ============================================================
   Vivía dentro de la sección, en un <script type="module"> de 54 KB
   que Shopify volvía a mandar en el HTML de CADA producto. El
   navegador no podía guardarlo: mismo código, descargado otra vez en
   cada ficha que abre el cliente.

   Fuera de la sección el archivo se cachea una vez y sirve para todo
   el catálogo, y sale del CDN de Shopify comprimido.

   Todo lo que dependía de Liquid --las variantes, los precios ya
   formateados por el filtro `money`, los textos del editor, las rutas--
   viaja en window.VX, que la sección declara justo antes de cargar
   este archivo. Aquí dentro NO puede quedar ni una marca de Liquid.
   ============================================================ */
(function(){
  var VX=window.VX||{};
  if(!VX.variants){return;}


  /* price_money / compare_money vienen ya formateados por el filtro `money`
     del servidor. Antes el JS armaba el precio a mano con '$'+toFixed(2)+cur,
     lo que daba "$1234.56 USD" mientras el servidor y la barra sticky decían
     "$1,234.56": tres formatos distintos conviviendo en la misma página, y
     con el símbolo $ y la moneda cableados a mano. */
  var variants=VX.variants;
  var opts={option1:VX.opts.option1,option2:VX.opts.option2,option3:VX.opts.option3};
  if(VX.variantImage)window.vxCurrentVariantImage=VX.variantImage;
  var vxSoldOutText=VX.soldOutText;
  var vxUnavailableText=VX.unavailableText;

  /* Bloqueo de scroll para los modales (zoom y cotización).
     Antes se hacía con document.body.style.overflow='hidden', que en desktop
     no bloquea nada: a partir de 990px Horizon le pone overflow:hidden al
     body y el que scrollea es .page-wrapper (assets/base.css), así que el
     fondo se seguía moviendo detrás del modal. El tema ya trae el mecanismo
     correcto: html[scroll-lock] apaga el overflow de html y de .page-wrapper
     a la vez, y es el mismo que usan los diálogos nativos. */
  window.vxLockScroll=function(on){
    var h=document.documentElement;
    if(on)h.setAttribute('scroll-lock','');
    else h.removeAttribute('scroll-lock');
  };

  function findV(){for(var i=0;i<variants.length;i++){var v=variants[i];if(v.option1===opts.option1&&v.option2===opts.option2&&v.option3===opts.option3)return v;}return null;}
  function findVById(id){for(var i=0;i<variants.length;i++){if(String(variants[i].id)===String(id))return variants[i];}return null;}

  /* Etiqueta legible de una variante -- "2400x1200 / Español".

     Sale de variant.title, que es exactamente lo que el servidor pinta en la
     barra fija al cargar la página, así que el valor inicial y el que escribe
     el JS al cambiar de variante tienen el mismo formato.

     Antes se armaba leyendo .vx-variant-section / .vx-variant-label /
     .vx-variant-btn.active del DOM. Esas tres clases murieron con el selector
     viejo de píldoras -- hoy el marcado emite .vx-vsel y .vx-vsel-opt -- así
     que la función devolvía siempre cadena vacía: la barra fija se quedaba en
     blanco en cuanto tocabas una opción, y la lista de deseos guardaba cada
     variante con variantName vacío. */
  function vxVariantLabel(v){
    if(!v||!v.title||v.title==='Default Title')return '';
    return v.title;
  }

  /* Porcentaje de descuento, redondeado al entero: la misma regla que el
     Liquid de la sección (times: 100.0 | divided_by | round) y la que fija
     MONEDA.md §4.3. Multiplica antes de dividir: (c-p)*100 es un entero
     exacto y el cociente sale bien redondeado, así un -12.5% exacto no
     depende de cómo cae la coma flotante. En centavos. */
  function vxDiscountPct(price,compare){
    if(!compare||compare<=price)return 0;
    return Math.round((compare-price)*100/compare);
  }

  /* El precio, el tachado y el porcentaje de una variante en las dos monedas
     (MONEDA.md §6.1 y §4.3). Liquid publica en window.VX, por variante, los
     céntimos en soles ya resueltos -- pen, pen_cmp y pen_src, con el precio
     fijado a mano si lo hay --, y VXMoney arma el mismo marcado que el
     snippet. Con la moneda apagada devuelven price_money y compare_money
     tal cual: el JS sigue sin componer moneda. */
  function vxPrecioHtml(v){
    return window.VXMoney?VXMoney.html(v.price,{usd:v.price_money,pen:v.pen,fuente:v.pen_src}):v.price_money;
  }
  function vxTachadoHtml(v){
    return window.VXMoney?VXMoney.html(v.compare_at_price,{usd:v.compare_money,pen:v.pen_cmp,fuente:v.pen_src}):v.compare_money;
  }
  function vxDescuentoHtml(v){
    if(window.VXMoney)return VXMoney.discountHtml(v.price,v.compare_at_price,{pen:v.pen,penCompare:v.pen_cmp,fuente:v.pen_src});
    return '-'+vxDiscountPct(v.price,v.compare_at_price)+'%';
  }

  /* Marca las opciones que no llevan a ninguna variante existente.
     Sin esto se podía elegir una combinación inexistente: findV() devolvía
     null, updateV salía sin hacer nada y el <input name="id"> se quedaba con
     la variante ANTERIOR — el usuario creía comprar A y compraba B. */
  function optionExists(key,val){
    var probe={option1:opts.option1,option2:opts.option2,option3:opts.option3};
    probe[key]=val;
    for(var i=0;i<variants.length;i++){
      var v=variants[i];
      if(v.option1===probe.option1&&v.option2===probe.option2&&v.option3===probe.option3)return v;
    }
    return null;
  }
  function refreshOptionStates(){
    document.querySelectorAll('.vx-vsel[data-option-index]').forEach(function(wrap){
      var key=wrap.getAttribute('data-option-index');
      wrap.querySelectorAll('.vx-vsel-opt').forEach(function(o){
        var match=optionExists(key,o.dataset.value);
        o.classList.toggle('vx-opt-missing',!match);
        o.classList.toggle('vx-opt-soldout',!!match&&!match.available);
      });
    });
  }

  /* Deja el botón en un estado honesto cuando la combinación elegida no
     corresponde a ninguna variante publicada. */
  function markNoVariant(){
    var b=document.getElementById('vxAddToCart');
    if(b){
      b.dataset.vxAvailable='false';
      b.disabled=true;
      var lbl=b.querySelector('.vx-btn-add-cart-label');
      if(lbl)lbl.textContent=vxUnavailableText;
    }
    var buy=document.getElementById('vxBuyNowBtn');
    if(buy)buy.disabled=true;
    refreshOptionStates();
  }

  function updateV(v){
    if(!v){markNoVariant();return;}
    var vidInput=document.getElementById('vxVariantId');if(vidInput)vidInput.value=v.id;
    var p=document.getElementById('vxProductPrice');if(p)p.innerHTML=vxPrecioHtml(v);
    var bp=document.getElementById('vxBtnPrice');if(bp)bp.innerHTML=vxPrecioHtml(v);
    var c=document.getElementById('vxComparePrice'),d=document.getElementById('vxDiscount');
    if(v.compare_at_price>v.price){
      if(c){c.innerHTML=vxTachadoHtml(v);c.style.display='';}
      if(d){d.innerHTML=vxDescuentoHtml(v);d.style.display='';}
    }else{
      if(c)c.style.display='none';
      if(d)d.style.display='none';
    }
    var b=document.getElementById('vxAddToCart');
    if(b){
      b.dataset.vxAvailable=v.available?'true':'false';
      b.disabled=!v.available;
      var lbl=b.querySelector('.vx-btn-add-cart-label');
      if(lbl)lbl.textContent=v.available?VX.addToCartText:vxSoldOutText;
    }
    var buyBtn=document.getElementById('vxBuyNowBtn');
    if(buyBtn)buyBtn.disabled=!v.available;
    refreshOptionStates();
    if(v.featured_image_src){
      window.vxCurrentVariantImage={src:v.featured_image_src,id:v.featured_image_id};
      var mc=document.getElementById('vxMainImage');
      var m=document.getElementById('vxMainImg');
      if(mc){var ov=mc.querySelector('#vxMainVideo,#vxMainExtVideo,#vxMainModel');if(ov)ov.remove();}
      if(m){
        m.style.display='';
        var src300=v.featured_image_src.replace(/width=\d+/,'width=300');
        m.src=src300;
        m.removeAttribute('srcset');
        m.style.opacity='1';
        var n=new Image();
        n.onload=function(){
          if(m.src.indexOf('width=300')>=0||m.src===src300){
            m.src=v.featured_image_src;
            var bs=v.featured_image_src.replace(/width=\d+/,'width=400')+' 400w, '+
                   v.featured_image_src.replace(/width=\d+/,'width=600')+' 600w, '+
                   v.featured_image_src+' 800w';
            m.setAttribute('srcset',bs);
          }
        };
        n.src=v.featured_image_src;
      }
      var thumbs=document.querySelectorAll('.vx-gallery-thumb');
      thumbs.forEach(function(t){
        if(String(t.dataset.imageId)===String(v.featured_image_id)){
          t.classList.add('active');
          var tC=document.getElementById('vxThumbs');
          if(tC)tC.scrollTo({left:t.offsetLeft-tC.offsetWidth/2+27,behavior:'smooth'});
        }else{
          t.classList.remove('active');
        }
      });
    }else{
      window.vxCurrentVariantImage=null;
    }
    /* Antes reescribía la URL como pathname+'?variant=', borrando cualquier
       otro parámetro — incluidos los utm_* de las campañas — en el primer
       cambio de variante. Ahora solo se toca la clave `variant`. */
    if(history.replaceState){
      try{
        var u=new URL(window.location.href);
        u.searchParams.set('variant',v.id);
        history.replaceState(null,'',u.pathname+u.search+u.hash);
      }catch(err){
        history.replaceState(null,'',window.location.pathname+'?variant='+v.id);
      }
    }
    document.dispatchEvent(new CustomEvent('vx:variant-change',{bubbles:true,detail:{variant:v}}));
  }
  window.vxToggleVariantDropdown=function(btn){
    var wrap=btn.closest('.vx-vsel');
    var wasOpen=wrap.classList.contains('open');
    document.querySelectorAll('.vx-vsel.open').forEach(function(w){
      w.classList.remove('open');
      var t=w.querySelector('.vx-vsel-btn');
      if(t)t.setAttribute('aria-expanded','false');
    });
    if(!wasOpen){
      wrap.classList.add('open');
      btn.setAttribute('aria-expanded','true');
    }
  };
  window.vxSelectDropdownOption=function(el,key,val){
    var wrap=el.closest('.vx-vsel');
    wrap.querySelectorAll('.vx-vsel-opt').forEach(function(o){
      o.classList.remove('active');
      o.setAttribute('aria-selected','false');
    });
    el.classList.add('active');
    el.setAttribute('aria-selected','true');
    wrap.querySelector('.vx-vsel-value').textContent=val;
    wrap.classList.remove('open');
    var toggle=wrap.querySelector('.vx-vsel-btn');
    if(toggle){toggle.setAttribute('aria-expanded','false');toggle.focus();}
    opts[key]=val;
    updateV(findV());
  };
  document.addEventListener('click',function(e){
    if(!e.target.closest('.vx-vsel')){
      document.querySelectorAll('.vx-vsel.open').forEach(function(w){
        w.classList.remove('open');
        var t=w.querySelector('.vx-vsel-btn');
        if(t)t.setAttribute('aria-expanded','false');
      });
    }
  });
  /* Estado inicial: marca de entrada las combinaciones inexistentes o agotadas. */
  refreshOptionStates();

  window.vxChangeMedia=function(t){
    var type=t.dataset.mediaType||'image';
    var mc=document.getElementById('vxMainImage');
    var m=document.getElementById('vxMainImg');
    var oldVid=mc.querySelector('#vxMainVideo,#vxMainExtVideo,#vxMainModel');
    if(oldVid)oldVid.remove();
    if(type==='video'){
      if(m)m.style.display='none';
      var v=document.createElement('video');
      v.id='vxMainVideo';v.src=t.dataset.videoSrc;v.playsInline=true;v.autoplay=true;v.loop=true;v.muted=true;v.preload='metadata';
      v.style.cssText='width:100%;height:100%;object-fit:contain;cursor:pointer';
      if(t.dataset.fullSrc)v.poster=t.dataset.fullSrc;
      v.onclick=function(){this.muted=!this.muted;};
      var arrows=mc.querySelectorAll('.vx-gallery-arrow');
      if(arrows.length)mc.insertBefore(v,arrows[0].nextSibling);else mc.appendChild(v);
    }else if(type==='external_video'){
      if(m)m.style.display='none';
      var host=t.dataset.videoHost,vid=t.dataset.videoId;
      var wrap=document.createElement('div');wrap.id='vxMainExtVideo';wrap.style.cssText='width:100%;height:100%;display:flex;align-items:center;justify-content:center';
      var iframe=document.createElement('iframe');iframe.style.cssText='width:100%;height:100%;border:none;border-radius:var(--vx-radius)';iframe.allow='autoplay;encrypted-media;fullscreen';iframe.allowFullscreen=true;
      if(host==='youtube')iframe.src='https://www.youtube.com/embed/'+vid+'?rel=0';
      else if(host==='vimeo')iframe.src='https://player.vimeo.com/video/'+vid;
      wrap.appendChild(iframe);
      var arrows=mc.querySelectorAll('.vx-gallery-arrow');
      if(arrows.length)mc.insertBefore(wrap,arrows[0].nextSibling);else mc.appendChild(wrap);
    }else{
      var thumbsAll=Array.from(document.querySelectorAll('.vx-gallery-thumb'));
      var oldIdx=thumbsAll.findIndex(function(x){return x.classList.contains('active');});
      var newIdx=thumbsAll.indexOf(t);
      var dir=(oldIdx>-1&&newIdx>-1&&newIdx!==oldIdx)?(newIdx>oldIdx?1:-1):0;
      if(m){
        var pre=new Image();pre.src=t.dataset.fullSrc;
        var isMobileSwap=window.innerWidth<750;
        var dist=dir>0?-28:(dir<0?28:0);
        m.style.display='';
        m.style.transition='transform .22s ease,opacity .22s ease';
        if(isMobileSwap&&dist!==0)m.style.transform='translateX('+dist+'px)';
        m.style.opacity='0';
        setTimeout(function(){
          m.src=t.dataset.fullSrc;if(t.dataset.srcset)m.srcset=t.dataset.srcset;
          m.style.transition='none';
          if(isMobileSwap&&dist!==0)m.style.transform='translateX('+(-dist)+'px)';
          void m.offsetWidth;
          m.style.transition='transform .22s ease,opacity .22s ease';
          m.style.transform='translateX(0)';
          m.style.opacity='1';
        },220);
      }
    }
    document.querySelectorAll('.vx-gallery-thumb').forEach(function(x){x.classList.remove('active');});t.classList.add('active');
  };

  var vxImgIdx=0;
  function getThumbList(){return Array.from(document.querySelectorAll('.vx-gallery-thumb'));}
  window.vxNavImage=function(dir){
    var thumbs=getThumbList();if(!thumbs.length)return;
    vxImgIdx=Math.max(0,Math.min(thumbs.length-1,vxImgIdx+dir));
    thumbs[vxImgIdx].click();
    thumbs.forEach(function(t,i){t.classList.toggle('active',i===vxImgIdx);});
    var tC=document.getElementById('vxThumbs');
    if(tC)tC.scrollTo({left:thumbs[vxImgIdx].offsetLeft-tC.offsetWidth/2+32,behavior:'smooth'});
  };
  document.querySelectorAll('.vx-gallery-thumb').forEach(function(t,i){t.addEventListener('click',function(){vxImgIdx=i;});});
  var sx=0;
  var mc=document.getElementById('vxMainImage');
  if(mc){
    mc.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
    mc.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>40)vxNavImage(dx<0?1:-1);},{passive:true});
  }

  /* Galería "pegajosa" en desktop -- sigue el scroll de .page-wrapper
     (el contenedor real que scrollea en Horizon, no window) hasta que
     el borde inferior de la columna de info alcanza al de la galería,
     y ahí se detiene para que terminen juntas. No usa position:sticky
     porque .page-wrapper tiene overflow:auto, que lo rompe (ver nota
     en el CSS de .vx-gallery).

     El punto de referencia de arriba se mide directo del borde
     inferior de #vxh-f2 (el menú del header), que SIEMPRE está
     visible sin importar si F1 (logo+buscador) está mostrado u
     oculto -- se mide en cada frame, sin predecir ni guardar estados
     por separado, así siempre refleja la realidad tal cual está en
     pantalla en ese momento. */
  (function(){
    var gallery=document.getElementById('vxGallery');
    var info=document.querySelector('.vx-product-info');
    var scrollEl=document.querySelector('.page-wrapper');
    var f2=document.getElementById('vxh-f2');
    if(!gallery||!info||!scrollEl)return;
    var EXTRA_GAP=12;
    var galleryNaturalOffsetTop=0, infoBottomOffsetTop=0, galleryHeight=0;

    function getTopGap(){
      if(f2)return Math.max(0, f2.getBoundingClientRect().bottom)+EXTRA_GAP;
      return 20;
    }

    /* La barra de pestañas es position:sticky con top:0, o sea que se pegaba
       al borde del viewport — justo debajo del header, que es position:fixed
       con z-index 490 contra el z-index 10 de la barra. Resultado: al
       scrollear dentro de las pestañas la barra desaparecía tapada por F2.
       Se publica la altura real de F2 (que ya se mide acá en cada frame para
       la galería) y el CSS la usa como top. */
    function publishStickyTop(){
      var top=f2?Math.max(0, f2.getBoundingClientRect().bottom):0;
      document.documentElement.style.setProperty('--vx-sticky-top', top+'px');
    }

    function measure(){
      gallery.style.transform='';
      var scrollTopNow=scrollEl.scrollTop;
      var wrapperTop=scrollEl.getBoundingClientRect().top;
      galleryNaturalOffsetTop=gallery.getBoundingClientRect().top-wrapperTop+scrollTopNow;
      galleryHeight=gallery.offsetHeight;
      infoBottomOffsetTop=info.getBoundingClientRect().bottom-wrapperTop+scrollTopNow;
      update();
    }

    function update(){
      publishStickyTop();
      if(window.innerWidth<990){gallery.style.transform='';return;}
      var scrollTopNow=scrollEl.scrollTop;
      var topGap=getTopGap();
      var shift=Math.max(0, scrollTopNow-(galleryNaturalOffsetTop-topGap));
      var naturalBottom=galleryNaturalOffsetTop+galleryHeight;
      var maxAllowedShift=Math.max(0, infoBottomOffsetTop-naturalBottom);
      if(shift>maxAllowedShift)shift=maxAllowedShift;
      gallery.style.transform='translateY('+shift+'px)';
    }

    /* requestAnimationFrame en vez de actualizar en cada evento de scroll
       tal cual llega -- sincroniza la escritura con el ciclo de dibujado
       del navegador, para que el movimiento se sienta parejo y no a
       saltos. */
    var ticking=false;
    function onScroll(){
      if(!ticking){
        requestAnimationFrame(function(){update();ticking=false;checkHeaderStateChange();});
        ticking=true;
      }
    }

    /* La transición del header (0.34s) sigue moviéndose incluso después
       de que el usuario dejó de scrollear -- sin este seguimiento activo,
       la galería se queda congelada en el último evento de scroll
       mientras F2 se sigue moviendo solo, generando el desfase visual.
       Al detectar el cambio de estado se sigue actualizando por un rato
       más, sin depender de que lleguen más eventos de scroll. */
    var headerWrapForTracking=document.getElementById('vxh-header-wrap');
    var lastHeaderScrolledState=headerWrapForTracking?headerWrapForTracking.classList.contains('vxh-wrap--scrolled'):false;
    var transitionTrackingUntil=0;
    function checkHeaderStateChange(){
      if(!headerWrapForTracking)return;
      var nowScrolled=headerWrapForTracking.classList.contains('vxh-wrap--scrolled');
      if(nowScrolled!==lastHeaderScrolledState){
        lastHeaderScrolledState=nowScrolled;
        transitionTrackingUntil=performance.now()+400;
        trackTransition();
      }
    }
    function trackTransition(){
      update();
      if(performance.now()<transitionTrackingUntil){
        requestAnimationFrame(trackTransition);
      }
    }

    scrollEl.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',measure);
    window.addEventListener('load',measure);
    measure();
  })();

  var vxAddBtn=document.getElementById('vxAddToCart');
  var vxCartBtnText=VX.addToCartText;

  window.vxSelectedShipVariant='peru';
  window.vxSelectShip=function(type,btn){
    window.vxSelectedShipVariant=type;
    document.querySelectorAll('.vx-ship-var-btn').forEach(function(b){b.classList.remove('active');});
    if(btn)btn.classList.add('active');
    document.querySelectorAll('.vx-ship-price-display').forEach(function(d){
      d.classList.toggle('active', d.getAttribute('data-ship-price')===type);
    });
    if(window.vxUpdateStickyShip)window.vxUpdateStickyShip(type);
  };

  window.vxCotizarClick=function(){
    var type=window.vxSelectedShipVariant||'peru';
    if(typeof vxCotizOpen==='function'){vxCotizOpen(type);}
  };

  (function(){
    function watchCartDialog(){
      var dlg=document.querySelector('#cart-drawer dialog, cart-drawer-component dialog');
      if(!dlg)return;
      new MutationObserver(function(){
        if(dlg.hasAttribute('open')){document.dispatchEvent(new CustomEvent('vx:cart-opened'));}
      }).observe(dlg,{attributes:true,attributeFilter:['open']});
    }
    if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',watchCartDialog);}
    else{watchCartDialog();}
  })();

  /* Nombres reales de los eventos de carrito de Shopify (assets/standard-events.d.ts).
     Se escuchan por string para no depender del import de @shopify/events. */
  var VX_CART_LINES_UPDATE='shopify:cart:lines-update';
  var VX_CART_ERROR='shopify:cart:error';

  /* Muestra un mensaje en el mismo contenedor que usa product-form.js
     (ref="addToCartTextError"), para que los errores propios y los nativos
     se vean igual. */
  window.vxShowCartError=function(msg){
    var box=document.querySelector('#vxProductFormComponent [ref="addToCartTextError"]');
    if(!box||!msg)return;
    /* product-form.js escribe en childNodes[2] (el nodo de texto que queda
       después del svg). Usamos el mismo hueco para no terminar con dos
       mensajes distintos apilados en la misma caja. */
    var slot=box.childNodes[2];
    if(slot&&slot.nodeType===3)slot.textContent=msg;
    else box.appendChild(document.createTextNode(msg));
    box.classList.remove('hidden');
    clearTimeout(window._vxCartErrTimer);
    window._vxCartErrTimer=setTimeout(function(){box.classList.add('hidden');},6000);
  };

  if(vxAddBtn){
    /* El botón es type=submit dentro de product-form-component, que ya maneja
       el submit nativamente. Solo escuchamos 'submit' para el feedback visual
       — sin llamar requestSubmit() de nuevo, que causaba doble submit.

       El re-enable ya no es un setTimeout a ciegas de 1.8s: si la petición
       tardaba más, el botón se reactivaba antes de terminar y se podía
       agregar dos veces. Ahora se reactiva cuando el carrito confirma
       (shopify:cart:lines-update, esperando su promise) o cuando falla
       (shopify:cart:error), con un timeout largo solo como red de seguridad. */
    var vxForm=document.getElementById('vxProductForm');
    var vxLabel=vxAddBtn.querySelector('.vx-btn-add-cart-label');
    var vxSafety=null;

    function vxResetAddBtn(){
      clearTimeout(vxSafety);
      vxAddBtn.disabled=!vxAddBtn.dataset.vxAvailable||vxAddBtn.dataset.vxAvailable==='false';
      if(vxLabel)vxLabel.textContent=vxAddBtn.disabled?VX.soldOutText:vxCartBtnText;
    }
    vxAddBtn.dataset.vxAvailable=VX.currentAvailable;

    if(vxForm){
      vxForm.addEventListener('submit',function(){
        if(vxAddBtn.disabled)return;
        vxAddBtn.disabled=true;
        if(vxLabel)vxLabel.textContent='Añadiendo...';
        clearTimeout(vxSafety);
        vxSafety=setTimeout(vxResetAddBtn,12000);
      });
    }
    document.addEventListener(VX_CART_LINES_UPDATE,function(e){
      var p=e.detail&&e.detail.promise;
      if(p&&typeof p.finally==='function')p.finally(vxResetAddBtn);
      else vxResetAddBtn();
    });
    /* Solo reactiva el botón: el mensaje ya lo pinta product-form.js en
       ref="addToCartTextError" ahora que ese contenedor existe. */
    document.addEventListener(VX_CART_ERROR,vxResetAddBtn);
    document.addEventListener('vx:cart-opened',vxResetAddBtn);
  }

  /* "Comprar ahora"
     Antes: window.location.href='/cart/'+vid+':'+qty+'?payment=shop_pay'.
     Eso es un cart permalink, y los permalinks de Shopify REEMPLAZAN el
     carrito en vez de agregar: quien tuviera otros planos adentro los
     perdía al comprar uno nuevo. Ahora se agrega con /cart/add.js
     (respetando lo que ya haya) y recién ahí se va al checkout. */
  var VX_CHECKOUT_URL=VX.checkoutUrl;
  window.vxBuyNow=function(btn){
    var form=document.getElementById('vxProductForm');
    if(!form)return;
    /* En soles el checkout cobraría en dólares: abre WhatsApp con este
       producto, la variante elegida y la cantidad, sin tocar el carrito
       (MONEDA.md §7.3, assets/vx-pago-whatsapp.js). */
    if(window.VXPagoWhatsApp&&VXPagoWhatsApp.activo()){
      var vwa=findVById((document.getElementById('vxVariantId')||{}).value);
      if(!vwa||!vwa.available)return;
      var qwa=document.getElementById('vxQtyInput');
      VXPagoWhatsApp.comprar({titulo:VX.productTitle,variante:vxVariantLabel(vwa),cantidad:qwa?qwa.value:1,precioCents:vwa.price,penCentimos:vwa.pen,url:VX.productUrl,variantId:vwa.id});
      return;
    }
    if(btn){
      if(btn.disabled)return;
      btn.disabled=true;
      if(!btn.dataset.vxLabel)btn.dataset.vxLabel=btn.innerHTML;
      btn.innerHTML='<strong>Procesando…</strong>';
    }
    function restore(){
      if(!btn)return;
      btn.disabled=false;
      if(btn.dataset.vxLabel)btn.innerHTML=btn.dataset.vxLabel;
    }
    fetch((window.Theme&&Theme.routes&&Theme.routes.cart_add_url)||'/cart/add.js',{
      method:'POST',
      headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      body:new FormData(form)
    })
      .then(function(r){return r.json();})
      .then(function(data){
        if(data&&data.status){
          window.vxShowCartError(data.description||data.message||'');
          restore();
          return;
        }
        window.location.href=VX_CHECKOUT_URL;
      })
      .catch(function(){
        window.vxShowCartError('No se pudo procesar la compra. Intenta de nuevo.');
        restore();
      });
  };

  /* Respeta min / max / step reales del input, que ahora salen de
     quantity_rule y del inventario (antes era siempre min 1 y sin techo). */
  window.vxChangeQty=function(d){
    var i=document.getElementById('vxQtyInput');
    if(!i)return;
    var step=parseInt(i.step,10)||1;
    var min=parseInt(i.min,10)||1;
    var max=i.max!==''?parseInt(i.max,10):null;
    var next=(parseInt(i.value,10)||min)+(d*step);
    if(next<min)next=min;
    if(max!==null&&!isNaN(max)&&next>max){
      next=max;
      window.vxShowCartError('Solo quedan '+max+' unidades disponibles.');
    }
    i.value=next;
    i.dispatchEvent(new Event('change',{bubbles:true}));
  };

  window.vxCopyProductLink=function(btn){
    var url=window.location.href;
    if(navigator.clipboard){
      navigator.clipboard.writeText(url).then(function(){
        btn.classList.add('is-copied');
        setTimeout(function(){btn.classList.remove('is-copied');},1800);
      }).catch(function(){});
    }
  };

  window.vxSwitchTab=function(id){
    document.querySelectorAll('.vx-tab-btn').forEach(function(b){
      var oc=b.getAttribute('onclick')||'';
      var on=oc.indexOf("'"+id+"'")!==-1;
      b.classList.toggle('active',on);
      b.setAttribute('aria-selected',on?'true':'false');
    });
    document.querySelectorAll('.vx-tab-content').forEach(function(c){
      c.classList.toggle('active',c.id==='vx-tab-'+id);
    });
  };

  window.vxSwitchFaqCat=function(cat,btn){
    document.querySelectorAll('.vx-faq-cat-btn').forEach(function(b){
      b.classList.remove('active');
      b.setAttribute('aria-selected','false');
    });
    if(btn){btn.classList.add('active');btn.setAttribute('aria-selected','true');}
    document.querySelectorAll('.vx-faq-group').forEach(function(g){
      g.classList.toggle('active', g.getAttribute('data-faq-cat')===cat);
    });
  };
  window.vxToggleFaq=function(btn){
    var item=btn.closest('.vx-faq-item');
    if(!item)return;
    var open=item.classList.toggle('open');
    btn.setAttribute('aria-expanded',open?'true':'false');
  };
  /* Acordeones. Reemplaza a vxToggleFilesIncluded, que abria contra un
     max-height fijo de 400px y recortaba en silencio cualquier contenido
     mas largo. Ahora el CSS anima grid-template-rows de 0fr a 1fr, que
     va hasta la altura real y no tiene tope. */
  window.vxToggleAcc=function(btn){
    var item=btn.closest('.vx-acc-item');
    if(!item)return;
    var open=item.classList.toggle('open');
    btn.setAttribute('aria-expanded',open?'true':'false');
  };

  /* El titulo NO se autoajusta.

     Hubo aqui un script que medía el titulo y le bajaba el cuerpo hasta
     que cupiera en una sola linea. Era resolver el problema equivocado:
     la columna es fija y es el titulo el que se adapta a ella, partiendo
     en dos renglones como cualquier encabezado. Lo que sobraba no era el
     numero de lineas sino la MEDIDA -- 55 caracteres seguidos son ~48 por
     renglon y un encabezado se lee mal por encima de 35. Eso se resuelve
     en CSS con max-width:18.5em sobre .vx-product-title, sin JS. */

  /* Entrada al hacer scroll para el banner, las tarjetas de servicio y
     los badges. Mismo disparador que ya mueve la barra fija y la pestana
     flotante: no hace falta maquinaria nueva. */
  (function(){
    var piezas=document.querySelectorAll('.vx-rise');
    if(!piezas.length)return;
    if(!('IntersectionObserver' in window)){
      piezas.forEach(function(el){el.classList.add('vx-in');});
      return;
    }
    var obs=new IntersectionObserver(function(entradas){
      entradas.forEach(function(e){
        if(!e.isIntersecting)return;
        e.target.classList.add('vx-in');
        obs.unobserve(e.target);
      });
    },{threshold:.12,rootMargin:'0px 0px -40px 0px'});
    piezas.forEach(function(el){obs.observe(el);});
  })();

  /* Acá se construían los puntos y las flechas de scroll de las pestañas y
     se escuchaba scroll y resize para actualizarlos. El contenedor
     (.vx-tabs-scroll-hint) estaba oculto con display:none!important en todos
     los anchos, así que era trabajo para nada. Se retiró con su markup. */

  var ft=document.getElementById('vxFloatTab'),ts=document.getElementById('vxTabsSection');
  if(ft&&ts&&window.innerWidth<=960){
    ft.style.display='flex';
    new IntersectionObserver(function(entries){entries.forEach(function(e){
      ft.style.opacity=e.isIntersecting?'0':'1';
      ft.style.pointerEvents=e.isIntersecting?'none':'auto';
      ft.classList.toggle('vx-point-up',e.boundingClientRect.top<0);
    });},{threshold:0.1}).observe(ts);
  }

  (function(){
    var btn=document.getElementById('vxWishBtn');
    var toast=document.getElementById('vxWishToast');
    var toastTxt=document.getElementById('vxWishToastTxt');
    var toastTimer=null;
    var isWishlisted=false;
    function getCurrentVariantId(){var el=document.getElementById('vxVariantId');return el?el.value:VX.currentId;}
    /* El almacen de la lista vive en assets/vx-wishlist.js, compartido con
       las tarjetas de coleccion, las de destacados y la pagina de la lista.
       Antes cada uno tenia su copia y guardaban formas distintas. */
    function isVariantInList(){var vid=getCurrentVariantId();return vid?VXWish.has(vid):false;}
    function updateHeaderCount(){VXWish.syncCount();}
    function showToast(msg){if(!toast||!toastTxt)return;toastTxt.textContent=msg;toast.classList.add('visible');if(toastTimer)clearTimeout(toastTimer);toastTimer=setTimeout(function(){toast.classList.remove('visible');},2200);}
    function flyHeart(){
      if(!btn)return;var headerIcon=document.querySelector('.vx-wish-header-icon');if(!headerIcon)return;
      var bR=btn.getBoundingClientRect(),hR=headerIcon.getBoundingClientRect();
      var h=document.createElement('div');h.className='vx-flying-heart';h.innerHTML='<svg viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
      h.style.left=(bR.left+bR.width/2-10)+'px';h.style.top=(bR.top+bR.height/2-10)+'px';
      document.body.appendChild(h);h.offsetWidth;h.classList.add('fly');
      h.style.left=(hR.left+hR.width/2-4)+'px';h.style.top=(hR.top+hR.height/2-4)+'px';
      setTimeout(function(){headerIcon.classList.add('vx-wish-header-pulse');updateHeaderCount();setTimeout(function(){headerIcon.classList.remove('vx-wish-header-pulse');},500);},650);
      setTimeout(function(){if(h.parentNode)h.parentNode.removeChild(h);},800);
    }
    function setVisual(state,skipAnim){
      isWishlisted=state;if(window.vxSyncStickyWish)window.vxSyncStickyWish(state);if(!btn)return;
      var tip=btn.querySelector('.vx-wish-tip');
      if(state){btn.classList.add('wishlisted');if(tip)tip.textContent='En tu lista de deseos';if(!skipAnim){btn.classList.add('vx-bounce');setTimeout(function(){btn.classList.remove('vx-bounce');},400);flyHeart();showToast('Añadido a tu lista ♥');}}
      else{btn.classList.remove('wishlisted');if(tip)tip.textContent='Añadir a lista de deseos';if(!skipAnim){showToast('Eliminado de tu lista');updateHeaderCount();}}
    }
    if(btn){
      btn.addEventListener('click',function(e){
        e.preventDefault();e.stopPropagation();var vid=getCurrentVariantId();if(!vid)return;
        if(isVariantInList()){VXWish.remove(vid);setVisual(false);}
        else{
          var mainImg=document.getElementById('vxMainImg');
          /* El precio sale de la variante, no de rascar el texto de la
             pantalla. Ese rascado llevaba un .replace(/^\./,'') que solo
             existia para sobrevivir al "$.36.00 USD" que pinta el formato
             de moneda mal puesto de la tienda (MONEDA-SOLES.md 6.5). */
          var vObj=findVById(vid);
          VXWish.add({variantId:vid,productId:VX.productId,name:VX.productTitle,variantName:vxVariantLabel(vObj),image:mainImg?mainImg.src:VX.productImage,priceCents:vObj?vObj.price:0,currency:VX.currency,handle:VX.productHandle,link:VX.productUrl+'?variant='+vid});
          setVisual(true);
        }
      });
    }
    var lastVid=getCurrentVariantId();
    /* Antes: setInterval(200ms) para detectar cambio de variante — reemplazado
       por el evento vx:variant-change que ya se emite en updateV(),
       eliminando el polling continuo cada 200ms durante toda la sesión */
    document.addEventListener('vx:variant-change',function(e){
      var v=e.detail&&e.detail.variant;if(!v)return;
      var vid=String(v.id);
      if(vid&&vid!==lastVid){lastVid=vid;if(isVariantInList()!==isWishlisted)setVisual(isVariantInList(),true);}
    });
    setTimeout(function(){if(isVariantInList())setVisual(true,true);updateHeaderCount();},300);
  })();

  (function(){
    var stickyWrapper=document.getElementById('vxStickyCart');
    var stickyBar=document.getElementById('vxStickyBar');
    var stickyBtn=document.getElementById('vxStickyBtn');
    var stickyBtnText=document.getElementById('vxStickyBtnText');
    var stickyVariant=document.getElementById('vxStickyVariant');
    var stickyPrice=document.getElementById('vxStickyPrice');
    var stickyDiscount=document.getElementById('vxStickyDiscount');
    var stickyImg=document.getElementById('vxStickyImg');
    var stickyWishBtn=document.getElementById('vxStickyWishBtn');
    var mainBtn=document.getElementById('vxAddToCart')||document.getElementById('vxCotizarBtn');
    var tabsSection=document.getElementById('vxTabsSection');
    var mainBtnText=VX.addToCartText;
    var priceIntlFmt=VX.priceIntlFmt;
    var penPriceRaw=VX.penPriceRaw;
    var penPriceFmt=penPriceRaw?'S/. '+penPriceRaw+' PEN':null;
    if(!stickyBar)return;
    var isMobile=window.innerWidth<750;
    var triggerEl=mainBtn||tabsSection;
    if(!triggerEl)return;
    new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        var show=!e.isIntersecting;
        if(isMobile&&mainBtn){var r=mainBtn.getBoundingClientRect();if(r.bottom>0&&r.top<window.innerHeight)show=false;}
        stickyBar.setAttribute('data-stuck',show?'true':'false');
        stickyBar.setAttribute('aria-hidden',show?'false':'true');
        /* aria-hidden y pointer-events:none no sacan la barra del orden de
           tabulación: escondida, sus botones se seguían pudiendo enfocar con
           Tab. inert sí los saca. */
        stickyBar.inert=!show;
        document.body.classList.toggle('vx-sticky-active',show);
      });
    },{threshold:0}).observe(triggerEl);
    window.addEventListener('resize',function(){isMobile=window.innerWidth<750;},{passive:true});
    if(stickyBtn){
      stickyBtn.addEventListener('click',function(){
        if(stickyBtn.disabled)return;stickyBtn.disabled=true;
        if(stickyBtnText)stickyBtnText.textContent='Añadiendo...';
        var form=document.getElementById('vxProductForm');
        if(form&&typeof form.requestSubmit==='function')form.requestSubmit();
        setTimeout(function(){stickyBtn.disabled=false;if(stickyBtnText)stickyBtnText.textContent=mainBtnText;},4000);
      });
    }
    var compareIntlFmt=VX.compareIntlFmt;
    var intlDiscPct=VX.intlDiscPct;
    var penCompareFmt=VX.penCompareFmt;
    var penDiscPct=VX.penDiscPct;
    window.vxUpdateStickyShip=function(type){
      if(stickyVariant)stickyVariant.textContent=type==='peru'?'Perú':'Internacional';
      if(stickyPrice){
        if(type==='peru'&&penPriceFmt){
          var html='<span>S/. '+penPriceRaw+'</span>';
          if(penCompareFmt&&penDiscPct>0)html+=' <s class="vx-sticky-cart__price-compare">S/. '+penCompareFmt+'</s>';
          stickyPrice.innerHTML=html;
          if(stickyDiscount&&penDiscPct>0){stickyDiscount.textContent='-'+penDiscPct+'%';stickyDiscount.style.display='';}
          else if(stickyDiscount){stickyDiscount.style.display='none';}
        }else{
          var html='<span class="vx-sticky-cart__price-sale">'+priceIntlFmt+'</span>';
          if(compareIntlFmt&&intlDiscPct>0)html+=' <s class="vx-sticky-cart__price-compare">'+compareIntlFmt+'</s>';
          stickyPrice.innerHTML=html;
          if(stickyDiscount&&intlDiscPct>0){stickyDiscount.textContent='-'+intlDiscPct+'%';stickyDiscount.style.display='';}
          else if(stickyDiscount){stickyDiscount.style.display='none';}
        }
      }
    };
    if(stickyWishBtn){stickyWishBtn.addEventListener('click',function(){var mw=document.getElementById('vxWishBtn');if(mw)mw.click();});}
    window.vxSyncStickyWish=function(state){if(!stickyWishBtn)return;state?stickyWishBtn.classList.add('wishlisted'):stickyWishBtn.classList.remove('wishlisted');};
    document.addEventListener('vx:cart-opened',function(){if(stickyBtn)stickyBtn.disabled=false;if(stickyBtnText)stickyBtnText.textContent=mainBtnText;});
    /* El valor inicial de la etiqueta lo pinta el servidor con
       current_variant.title. Acá había una función que lo recalculaba leyendo
       el DOM al cargar, y quedaba tapada por su propia guarda porque siempre
       devolvía cadena vacía. Se retira: el único momento en que esto tiene
       que cambiar es al cambiar de variante, y de eso se ocupa el listener
       de abajo. */
    document.addEventListener('vx:variant-change',function(e){
      var v=e.detail&&e.detail.variant;if(!v)return;
      stickyWrapper&&stickyWrapper.setAttribute('data-variant-available',v.available?'true':'false');
      if(stickyBtn)stickyBtn.disabled=!v.available;
      /* En un producto de cotización esta misma línea la maneja
         vxUpdateStickyShip con "Perú" / "Internacional": ahí la etiqueta no es
         la variante, es el destino del envío. */
      if(stickyVariant&&!VX.isCotizacion)stickyVariant.textContent=vxVariantLabel(v);
      if(stickyPrice){
        /* Usa el precio ya formateado por el filtro `money` del servidor.
           Antes armaba el suyo con toLocaleString('en-US'), un tercer
           formato distinto del principal y del renderizado en Liquid. */
        stickyPrice.innerHTML=(v.compare_at_price&&v.compare_at_price>v.price)
          ?'<span class="vx-sticky-cart__price-sale">'+vxPrecioHtml(v)+'</span> <s class="vx-sticky-cart__price-compare">'+vxTachadoHtml(v)+'</s>'
          :'<span>'+vxPrecioHtml(v)+'</span>';
      }
      if(stickyDiscount){
        if(v.compare_at_price&&v.compare_at_price>v.price){stickyDiscount.innerHTML=vxDescuentoHtml(v);stickyDiscount.style.display='';}
        else{stickyDiscount.style.display='none';}
      }
      if(stickyImg){var src=v.featured_image_src||null;if(!src&&v.featured_image&&v.featured_image.src)src=v.featured_image.src;if(src){var cleanSrc=src.split('?')[0]+'?width=120&crop=center';stickyImg.src=cleanSrc;stickyImg.style.display='';}}
    });
  })();

  (function(){
    var modal=document.getElementById('vxCotizModal');if(!modal)return;
    document.body.appendChild(modal);
    var titleEl=document.getElementById('vxCotizTitle');
    var iconEl=document.getElementById('vxCotizIcon');
    var locLabel=document.getElementById('vxCotizLocationLabel');
    var nameInput=document.getElementById('vxCotizName');
    var locInput=document.getElementById('vxCotizLocation');
    var waBtn=document.getElementById('vxCotizWABtn');
    var waNumber=VX.waNumber;
    var productTitle=VX.productTitle;
    var priceIntl=VX.priceIntl;
    var pricePen=VX.pricePen;
    var currentType='intl';
    var lastFocused=null;
    function buildMsg(){
      var name=(nameInput.value||'').trim();var loc=(locInput.value||'').trim();
      var price=currentType==='intl'?priceIntl:pricePen;
      var dest=currentType==='intl'?'desde '+loc:'desde '+loc+', Perú';
      return encodeURIComponent('Hola, Vexial. Me gustaría cotizar el envío de "'+productTitle+'" ('+price+'). Soy '+name+', te escribo '+dest+'.');
    }
    function updateLink(){if(waBtn)waBtn.href='https://wa.me/'+waNumber+'?text='+buildMsg();}
    function markError(el){el.style.borderColor='#ef4444';el.addEventListener('input',function(){el.style.borderColor='';},{once:true});}
    if(waBtn){
      waBtn.addEventListener('click',function(e){
        var name=(nameInput.value||'').trim();var loc=(locInput.value||'').trim();var ok=true;
        if(!name){markError(nameInput);nameInput.focus();ok=false;}
        if(!loc){markError(locInput);if(ok)locInput.focus();ok=false;}
        if(!ok){e.preventDefault();return;}updateLink();
      });
    }
    [nameInput,locInput].forEach(function(i){if(i)i.addEventListener('input',updateLink);});
    window.vxCotizOpen=function(type){
      currentType=type;
      if(type==='intl'){if(iconEl)iconEl.textContent='Internacional';if(titleEl)titleEl.textContent='Cotizar envío internacional';if(locLabel)locLabel.textContent='País de destino';if(locInput)locInput.placeholder='Ej: México, Colombia, Chile...';}
      else{if(iconEl)iconEl.textContent='Perú';if(titleEl)titleEl.textContent='Cotizar envío en Perú';if(locLabel)locLabel.textContent='Departamento';if(locInput)locInput.placeholder='Ej: Lima, Cusco, Arequipa...';}
      if(nameInput){nameInput.value='';nameInput.style.borderColor='';}
      if(locInput){locInput.value='';locInput.style.borderColor='';}
      updateLink();
      modal.removeAttribute('style');
      modal.style.cssText='display:flex!important;position:fixed!important;inset:0!important;z-index:999998!important;pointer-events:auto!important;align-items:center!important;justify-content:center!important;background:rgba(0,0,0,0);transition:background .25s ease;padding:16px;box-sizing:border-box';
      window.vxLockScroll(true);
      modal.removeAttribute('aria-hidden');
      window._vxPreventScroll=function(e){var box=modal.querySelector('.vxcm-box');if(box&&box.contains(e.target))return;e.preventDefault();};
      document.addEventListener('touchmove',window._vxPreventScroll,{passive:false});
      requestAnimationFrame(function(){modal.classList.add('open');modal.style.setProperty('background','rgba(10,20,40,.52)','important');});
      /* Se recuerda quién tenía el foco para devolvérselo al cerrar: si no,
         al salir del modal el foco vuelve al <body> y quien navega con
         teclado tiene que recorrer la página entera de nuevo. */
      lastFocused=document.activeElement;
      if(nameInput)setTimeout(function(){nameInput.focus();},180);
    };
    window.vxCotizClose=function(){
      modal.classList.remove('open');modal.style.setProperty('background','rgba(0,0,0,0)','important');modal.setAttribute('aria-hidden','true');window.vxLockScroll(false);
      if(window._vxPreventScroll){document.removeEventListener('touchmove',window._vxPreventScroll);window._vxPreventScroll=null;}
      setTimeout(function(){modal.removeAttribute('style');},220);
      if(lastFocused&&typeof lastFocused.focus==='function')lastFocused.focus();
      lastFocused=null;
    };
    document.addEventListener('keydown',function(e){
      if(!modal.classList.contains('open'))return;
      if(e.key==='Escape'){vxCotizClose();return;}
      /* Con aria-modal="true" pero sin atrapar el Tab, el foco se escapaba
         detrás del overlay y se podía seguir tabulando por la página tapada. */
      if(e.key!=='Tab')return;
      var box=modal.querySelector('.vxcm-box');
      if(!box)return;
      var f=box.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),textarea:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])');
      if(!f.length)return;
      var first=f[0],last=f[f.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    });
  })();

  (function(){
    var modal=document.getElementById('vxZoomModal');
    var zoomImg=document.getElementById('vxZoomImg');
    var zoomLvl=document.getElementById('vxZoomLevel');
    var viewport=document.getElementById('vxZoomViewport');
    var mainImg=document.getElementById('vxMainImg');
    var mainCont=document.getElementById('vxMainImage');
    var scale=1,imgX=0,imgY=0,dragging=false,dragX=0,dragY=0;
    var zoomIdx=0;
    var zoomThumbsEl=document.getElementById('vxZoomThumbs');
    function zThumbs(){return Array.from(document.querySelectorAll('.vx-gallery-thumb'));}
    function zCurrentIdx(){var t=zThumbs();for(var i=0;i<t.length;i++){if(t[i].classList.contains('active'))return i;}return 0;}
    function buildZoomThumbs(){
      if(!zoomThumbsEl)return;
      var thumbs=zThumbs();
      if(thumbs.length<2){zoomThumbsEl.innerHTML='';return;}
      if(zoomThumbsEl.children.length===thumbs.length)return;
      zoomThumbsEl.innerHTML='';
      thumbs.forEach(function(t,i){
        var srcImg=t.querySelector('img');
        var b=document.createElement('button');
        b.type='button';b.className='vx-zoom-thumb';b.setAttribute('aria-label','Ver multimedia '+(i+1));
        if(srcImg){var im=document.createElement('img');im.src=srcImg.src;im.alt='';im.loading='lazy';im.width=52;im.height=52;b.appendChild(im);}
        b.addEventListener('click',function(e){e.stopPropagation();openZoomAt(i);});
        zoomThumbsEl.appendChild(b);
      });
    }
    function syncZoomThumbsActive(){
      if(!zoomThumbsEl)return;
      Array.from(zoomThumbsEl.children).forEach(function(el,i){el.classList.toggle('active',i===zoomIdx);});
    }
    var zoomArrowLeft=document.querySelector('.vx-zoom-arrow--left');
    var zoomArrowRight=document.querySelector('.vx-zoom-arrow--right');
    function syncZoomArrows(){
      var thumbs=zThumbs();
      var atStart=zoomIdx===-1||(zoomIdx<=0&&!window.vxCurrentVariantImage);
      var atEnd=zoomIdx>=thumbs.length-1;
      if(zoomArrowLeft){zoomArrowLeft.disabled=atStart;zoomArrowLeft.style.opacity=atStart?'.3':'1';zoomArrowLeft.style.pointerEvents=atStart?'none':'auto';}
      if(zoomArrowRight){zoomArrowRight.disabled=atEnd;zoomArrowRight.style.opacity=atEnd?'.3':'1';zoomArrowRight.style.pointerEvents=atEnd?'none':'auto';}
    }
    function openZoomAt(idx){
      var thumbs=zThumbs();
      if(idx===-1&&window.vxCurrentVariantImage){
        zoomIdx=-1;
        var srcV=window.vxCurrentVariantImage.src.replace(/width=\d+/,'width=1600');
        scale=1;imgX=0;imgY=0;zoomImg.src=srcV;zoomImg.style.transform='translate(0,0) scale(1)';
        if(zoomLvl)zoomLvl.textContent='100%';modal.style.display='flex';modal.removeAttribute('aria-hidden');window.vxLockScroll(true);
        buildZoomThumbs();syncZoomThumbsActive();syncZoomArrows();
        return;
      }
      if(!thumbs.length){
        if(!mainImg)return;
        var src0=(mainImg.currentSrc||mainImg.src).split('?')[0]+'?width=1600';
        scale=1;imgX=0;imgY=0;zoomImg.src=src0;zoomImg.style.transform='translate(0,0) scale(1)';
        if(zoomLvl)zoomLvl.textContent='100%';modal.style.display='flex';modal.removeAttribute('aria-hidden');window.vxLockScroll(true);
        return;
      }
      idx=Math.max(0,Math.min(thumbs.length-1,idx));
      zoomIdx=idx;
      var t=thumbs[idx];
      var src=(t.dataset.fullSrc||'').replace(/width=\d+/,'width=1600');
      scale=1;imgX=0;imgY=0;zoomImg.src=src;zoomImg.style.transform='translate(0,0) scale(1)';
      if(zoomLvl)zoomLvl.textContent='100%';modal.style.display='flex';modal.removeAttribute('aria-hidden');window.vxLockScroll(true);
      buildZoomThumbs();syncZoomThumbsActive();syncZoomArrows();
    }
    if(mainImg){
      mainImg.style.cursor='zoom-in';
      mainImg.addEventListener('click',function(e){
        e.stopPropagation();
        zoomImg.style.transition='none';zoomImg.style.opacity='1';
        if(window.vxCurrentVariantImage){
          openZoomAt(-1);
        }else{
          openZoomAt(zCurrentIdx());
        }
      });
    }
    window.vxZoomSlide=function(dir){
      var thumbs=zThumbs();
      if(zoomIdx===-1){
        if(dir<0)return;
        if(!thumbs.length)return;
        var distV=-32;
        zoomImg.style.transition='transform .22s ease,opacity .22s ease';
        zoomImg.style.transform='translateX('+distV+'px) scale('+scale+')';
        zoomImg.style.opacity='0';
        setTimeout(function(){
          thumbs[0].click();
          openZoomAt(0);
          zoomImg.style.transition='none';
          zoomImg.style.transform='translateX('+(-distV)+'px) scale(1)';
          zoomImg.style.opacity='0';
          void zoomImg.offsetWidth;
          zoomImg.style.transition='transform .22s ease,opacity .22s ease';
          zoomImg.style.transform='translate(0,0) scale(1)';
          zoomImg.style.opacity='1';
        },220);
        return;
      }
      if(zoomIdx===0&&dir<0&&window.vxCurrentVariantImage){
        var distB=32;
        zoomImg.style.transition='transform .22s ease,opacity .22s ease';
        zoomImg.style.transform='translateX('+distB+'px) scale('+scale+')';
        zoomImg.style.opacity='0';
        setTimeout(function(){
          openZoomAt(-1);
          zoomImg.style.transition='none';
          zoomImg.style.transform='translateX('+(-distB)+'px) scale(1)';
          zoomImg.style.opacity='0';
          void zoomImg.offsetWidth;
          zoomImg.style.transition='transform .22s ease,opacity .22s ease';
          zoomImg.style.transform='translate(0,0) scale(1)';
          zoomImg.style.opacity='1';
        },220);
        return;
      }
      if(thumbs.length<2)return;
      var newIdx=Math.max(0,Math.min(thumbs.length-1,zoomIdx+dir));
      if(newIdx===zoomIdx)return;
      var dist=dir>0?-32:32;
      zoomImg.style.transition='transform .22s ease,opacity .22s ease';
      zoomImg.style.transform='translateX('+dist+'px) scale('+scale+')';
      zoomImg.style.opacity='0';
      setTimeout(function(){
        thumbs[newIdx].click();
        openZoomAt(newIdx);
        zoomImg.style.transition='none';
        zoomImg.style.transform='translateX('+(-dist)+'px) scale(1)';
        zoomImg.style.opacity='0';
        void zoomImg.offsetWidth;
        zoomImg.style.transition='transform .22s ease,opacity .22s ease';
        zoomImg.style.transform='translate(0,0) scale(1)';
        zoomImg.style.opacity='1';
      },220);
    };
    if(viewport){
      var zsx=0,zSwiping=false;
      var pinching=false,pinchStartDist=0,pinchStartScale=1;
      var panning=false,panStartX=0,panStartY=0,panStartImgX=0,panStartImgY=0;
      viewport.addEventListener('touchstart',function(e){
        if(e.touches.length===2){
          pinching=true;zSwiping=false;panning=false;
          pinchStartDist=Math.hypot(e.touches[0].clientX-e.touches[1].clientX,e.touches[0].clientY-e.touches[1].clientY);
          pinchStartScale=scale;
        }else if(e.touches.length===1){
          pinching=false;
          if(scale>1){
            panning=true;zSwiping=false;
            panStartX=e.touches[0].clientX;panStartY=e.touches[0].clientY;
            panStartImgX=imgX;panStartImgY=imgY;
          }else{
            panning=false;
            zsx=e.touches[0].clientX;zSwiping=true;
          }
        }
      },{passive:true});
      viewport.addEventListener('touchmove',function(e){
        if(pinching&&e.touches.length===2){
          var d=Math.hypot(e.touches[0].clientX-e.touches[1].clientX,e.touches[0].clientY-e.touches[1].clientY);
          scale=Math.max(1,Math.min(5,pinchStartScale*(d/pinchStartDist)));
          applyTransform();
        }else if(panning&&e.touches.length===1){
          imgX=panStartImgX+(e.touches[0].clientX-panStartX);
          imgY=panStartImgY+(e.touches[0].clientY-panStartY);
          applyTransform();
        }
      },{passive:true});
      viewport.addEventListener('touchend',function(e){
        if(pinching){
          pinching=false;
          if(scale===1){imgX=0;imgY=0;applyTransform();}
          return;
        }
        if(panning){panning=false;return;}
        if(!zSwiping)return;zSwiping=false;
        var dx=e.changedTouches[0].clientX-zsx;
        if(Math.abs(dx)>45)window.vxZoomSlide(dx<0?1:-1);
      },{passive:true});
    }
    window.vxZoomClose=function(e){if(e&&e.target!==modal&&e.target!==viewport)return;modal.style.display='none';modal.setAttribute('aria-hidden','true');window.vxLockScroll(false);};
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&modal&&modal.style.display==='flex')vxZoomClose();});
    function applyTransform(){
      if(!zoomImg||!viewport)return;
      var maxX=Math.max(0,(zoomImg.offsetWidth*scale-viewport.offsetWidth)/2);
      var maxY=Math.max(0,(zoomImg.offsetHeight*scale-viewport.offsetHeight)/2);
      imgX=Math.max(-maxX,Math.min(maxX,imgX));imgY=Math.max(-maxY,Math.min(maxY,imgY));
      zoomImg.style.transform='translate('+imgX+'px,'+imgY+'px) scale('+scale+')';
      if(zoomLvl)zoomLvl.textContent=Math.round(scale*100)+'%';
      zoomImg.style.cursor=scale>1?'grab':'default';
    }
    window.vxZoomIn=function(){scale=Math.min(5,scale+0.5);applyTransform();};
    window.vxZoomOut=function(){scale=Math.max(1,scale-0.5);if(scale===1){imgX=0;imgY=0;}applyTransform();};
    viewport&&viewport.addEventListener('wheel',function(e){e.preventDefault();scale=Math.max(1,Math.min(5,scale+(e.deltaY<0?0.3:-0.3)));if(scale===1){imgX=0;imgY=0;}applyTransform();},{passive:false});
    zoomImg&&zoomImg.addEventListener('mousedown',function(e){if(scale<=1)return;dragging=true;dragX=e.clientX-imgX;dragY=e.clientY-imgY;zoomImg.style.cursor='grabbing';e.preventDefault();});
    document.addEventListener('mousemove',function(e){if(!dragging)return;imgX=e.clientX-dragX;imgY=e.clientY-dragY;applyTransform();});
    document.addEventListener('mouseup',function(){if(!dragging)return;dragging=false;if(zoomImg)zoomImg.style.cursor=scale>1?'grab':'default';});
  })();

  /* Acá se reescribía el <meta name="viewport"> global agregándole
     user-scalable=no, maximum-scale=1.0 en cualquier dispositivo táctil, y
     además se cancelaba todo touchmove de dos dedos fuera del modal de zoom.
     Entre las dos cosas quedaba el pinch-zoom bloqueado en toda la página:
     un incumplimiento de WCAG 1.4.4, y encima un efecto global disparado
     desde la página de producto sobre una etiqueta que es de todo el sitio.
     El modal de zoom tiene su propio manejo de pinch, así que no hace falta.

     Si el motivo original era evitar el zoom accidental al hacer doble tap
     sobre la galería, eso se resuelve con touch-action en el contenedor, no
     apagando el zoom de la página entera. */

  window.addEventListener('load',function(){
    setTimeout(function(){
      /* Precarga en el ancho EXACTO que usa vxChangeMedia (data-full-src,
         width:800) para que el cambio de imagen sea siempre un hit de
         caché, sin importar el dispositivo. Antes precargaba 600/1200px
         segun el viewport, que no coincidía con lo que en realidad se
         pedía al cambiar de imagen. Delay bajado de 1500ms a 500ms para
         que estén listas mucho antes. Puramente en segundo plano, no
         cambia nada visual. */
      /* Se precargan las primeras imágenes, no todas: en un producto con
         veinte fotos esto bajaba varios MB de fondo en cada visita para
         imágenes que la mayoría de la gente nunca llega a ver. Las que
         quedan fuera se descargan igual al pedirlas, solo sin adelanto. */
      var srcSet=new Set();
      VX.preload.forEach(function(src){srcSet.add(src);});
      srcSet.forEach(function(src){var img=new Image();img.src=src;});
    },500);
  });

})();
